import posthog from 'posthog-js';
import getConfig from '@src/util/getConfig';

const DISABLED_HOSTS = ['localhost', '127.0.0.1'];

let initialized = false;

export function isPostHogEnabled(): boolean {
    return initialized;
}

export function initPostHog(): void {
    if (typeof window === 'undefined') return;

    const config = getConfig();
    const key = config.posthog_key;
    const host = config.posthog_host;

    if (!key || !host) return;

    const hostname = window.location.hostname;
    const isDisabled = DISABLED_HOSTS.some((h) => hostname.includes(h))
        || hostname.includes('dev.');

    if (isDisabled) return;

    posthog.init(key, {
        api_host: host,
        person_profiles: 'identified_only',

        // Autocapture
        autocapture: true,
        capture_pageview: false,
        capture_pageleave: true,
        capture_dead_clicks: true,

        // Error tracking (replaces Sentry)
        autocapture_exceptions: true,
        // @ts-expect-error -- PostHog types may lag behind features
        capture_console_errors: true,

        // Session recording (replaces Zipy)
        session_recording: {
            maskAllInputs: true,
            maskTextSelector: '[data-sensitive]',
            minimum_duration: 3000,
            sample_rate: 0.1,
        },

        loaded: () => {
            initialized = true;
        },
    });
}

export { posthog };
